(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('vee-validate'), require('vue-the-mask')) :
  typeof define === 'function' && define.amd ? define(['exports', 'vee-validate', 'vue-the-mask'], factory) :
  (global = global || self, factory(global['n-inputs'] = {}, global.veeValidate, global.vueTheMask));
}(this, (function (exports, veeValidate, vueTheMask) { 'use strict';

  var eager = function (ref) {
    var errors = ref.errors;

    if (errors.length) {
      return {
        on: ['input', 'change']
      }
    }
    return {
      on: ['blur']
    }
  };

  var nInput = {
    components: {
      ValidationProvider: veeValidate.ValidationProvider
    },
    props: {
      mode: {
        type: Function,
        default: eager
      },
      id: {
        type: String,
        default: function () {
          var dt = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 || 0;
            dt = Math.floor(dt / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          });
          return uuid
        }
      },
      name: {
        type: String,
        required: true
      },
      rules: {
        type: String,
        default: ''
      },
      value: {
        type: [String, Number, Boolean]
      },
      placeholder: {
        type: String,
        default: ''
      },
      showIcons: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      displayError: {
        type: Boolean,
        default: true
      },
      forceValidate: {
        type: Boolean,
        default: false
      },
      textColor: {
        type: String,
        default: '#000000'
      },
      borderColor: {
        type: String,
        default: '#00A6B6'
      },
      errorColor: {
        type: String,
        default: '#FF3B30'
      }
    }
  };

  //
  var script = {
    name: 'n-text',
    props: {
      type: {
        type: String,
        default: 'text',
        validator: function (type) {
          return ['text', 'email', 'password', 'tel'].indexOf(type) !== -1
        }
      },
      designType: {
        type: String,
        required: false,
        default: 'line',
        validator: function (animationType) {
          return ['box', 'line'].indexOf(animationType) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: '#F3F3F3'
      }
    },
    mixins: [nInput],
    data: function data () {
      return {
        isFocus: false
      }
    },
    computed: {
      inputField: function inputField () { return this.$refs.inputField },
      hasSlots: function hasSlots () { return Object.keys(this.$slots).length > 0 },
      hasInfos: function hasInfos () { return Object.keys(this.$slots).length > 0 && this.$slots.informations },
      hasLabel: function hasLabel () { return Object.keys(this.$slots).length > 0 && this.$slots.default },
      hasIcon: function hasIcon () { return Object.keys(this.$slots).length > 0 && this.$slots.icon },
      isEmpty: function isEmpty () { return this.value === '' || this.value === null || this.value === undefined },
      ogValue: function ogValue () { return this.value },
      showError: function showError () { return (!this.isEmpty && this.$refs.provider && Object.keys(this.$refs.provider.failedRules)[0] && !Object.keys(this.$refs.provider.failedRules)[0].includes('required')) || !this.isFocus }
    },
    mounted: function mounted () {
      if (!this.isEmpty) {
        this.isValid();
      }
    },
    watch: {
      ogValue: 'isValid',
      forceValidate: function forceValidate (newVal, oldVal) {
        if (newVal) {
          this.isValid();
        }
      }
    },
    methods: {
      blur: function blur () {
        this.isFocus = false;
        this.$emit('onBlur', true);
        this.isValid();
      },
      focus: function focus () {
        this.isFocus = true;
        this.$emit('onBlur', false);
      },
      isValid: function isValid () {
        var this$1 = this;

        this.$refs.provider.validate(this.value)
          .then(function (result) {
            this$1.$emit('isValid', result.valid);
          });
      }
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
      if (typeof shadowMode !== 'boolean') {
          createInjectorSSR = createInjector;
          createInjector = shadowMode;
          shadowMode = false;
      }
      // Vue.extend constructor export interop.
      var options = typeof script === 'function' ? script.options : script;
      // render functions
      if (template && template.render) {
          options.render = template.render;
          options.staticRenderFns = template.staticRenderFns;
          options._compiled = true;
          // functional template
          if (isFunctionalTemplate) {
              options.functional = true;
          }
      }
      // scopedId
      if (scopeId) {
          options._scopeId = scopeId;
      }
      var hook;
      if (moduleIdentifier) {
          // server build
          hook = function (context) {
              // 2.3 injection
              context =
                  context || // cached call
                      (this.$vnode && this.$vnode.ssrContext) || // stateful
                      (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
              // 2.2 with runInNewContext: true
              if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                  context = __VUE_SSR_CONTEXT__;
              }
              // inject component styles
              if (style) {
                  style.call(this, createInjectorSSR(context));
              }
              // register component module identifier for async chunk inference
              if (context && context._registeredComponents) {
                  context._registeredComponents.add(moduleIdentifier);
              }
          };
          // used by ssr in case component is cached and beforeCreate
          // never gets called
          options._ssrRegister = hook;
      }
      else if (style) {
          hook = shadowMode
              ? function (context) {
                  style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
              }
              : function (context) {
                  style.call(this, createInjector(context));
              };
      }
      if (hook) {
          if (options.functional) {
              // register for functional component in vue file
              var originalRender = options.render;
              options.render = function renderWithStyleInjection(h, context) {
                  hook.call(context);
                  return originalRender(h, context);
              };
          }
          else {
              // inject component registration as beforeCreate hook
              var existing = options.beforeCreate;
              options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
      }
      return script;
  }

  var isOldIE = typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
  function createInjector(context) {
      return function (id, style) { return addStyle(id, style); };
  }
  var HEAD;
  var styles = {};
  function addStyle(id, css) {
      var group = isOldIE ? css.media || 'default' : id;
      var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
      if (!style.ids.has(id)) {
          style.ids.add(id);
          var code = css.source;
          if (css.map) {
              // https://developer.chrome.com/devtools/docs/javascript-debugging
              // this makes source maps inside style tags work properly in Chrome
              code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
              // http://stackoverflow.com/a/26603875
              code +=
                  '\n/*# sourceMappingURL=data:application/json;base64,' +
                      btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                      ' */';
          }
          if (!style.element) {
              style.element = document.createElement('style');
              style.element.type = 'text/css';
              if (css.media)
                  { style.element.setAttribute('media', css.media); }
              if (HEAD === undefined) {
                  HEAD = document.head || document.getElementsByTagName('head')[0];
              }
              HEAD.appendChild(style.element);
          }
          if ('styleSheet' in style.element) {
              style.styles.push(code);
              style.element.styleSheet.cssText = style.styles
                  .filter(Boolean)
                  .join('\n');
          }
          else {
              var index = style.ids.size - 1;
              var textNode = document.createTextNode(code);
              var nodes = style.element.childNodes;
              if (nodes[index])
                  { style.element.removeChild(nodes[index]); }
              if (nodes.length)
                  { style.element.insertBefore(textNode, nodes[index]); }
              else
                  { style.element.appendChild(textNode); }
          }
      }
  }

  /* script */
  var __vue_script__ = script;

  /* template */
  var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input n-text",class:("n-input-" + _vm.designType)},[_c('ValidationProvider',{ref:"provider",attrs:{"name":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var errors = ref.errors;
  var valid = ref.valid;
  return [_c('div',{staticClass:"n-input__container",class:{ 'valid': valid && !_vm.isEmpty, 'error': !!errors[0], 'active': _vm.isFocus || !_vm.isEmpty, 'disabled': _vm.disabled }},[(_vm.hasSlots)?_c('label',{staticClass:"n-input__label-text",style:({ color: _vm.isFocus ? _vm.borderColor : _vm.textColor }),attrs:{"for":_vm.id}},[_c('span',[_vm._t("default")],2)]):_vm._e(),_c('input',{ref:"inputField",style:({
            'color': _vm.textColor,
            'outline-color': errors[0] && !_vm.isFocus ? _vm.errorColor : _vm.borderColor,
            'border-color': errors[0] && !_vm.isFocus && _vm.designType !== 'box' ? _vm.errorColor :
            !_vm.isFocus && _vm.designType === 'box' ? _vm.backgroundColor : _vm.borderColor,
            'background-color': _vm.designType === 'line' && !_vm.isFocus ? 'transparent' : _vm.backgroundColor,
            'padding-right': _vm.hasIcon ? '0.9em' : '0.7em'
          }),attrs:{"type":_vm.type,"id":_vm.id,"placeholder":_vm.placeholder},domProps:{"value":_vm.ogValue},on:{"input":function ($event) { return _vm.$emit('input', $event.target.value); },"focus":_vm.focus,"blur":_vm.blur}}),(_vm.showIcons && errors[0])?_c('span',{staticClass:"n-input__error-icon",style:({'top': _vm.hasLabel ? '2.4em': '0.8em'})},[_c('span',[_c('svg',{staticClass:"error-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"12","height":"12","viewBox":"0 0 12 12"}},[_c('defs',[_c('clipPath',{attrs:{"id":"error-path"}},[_c('path',{staticClass:"error-path",attrs:{"d":"M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z"}})])]),_c('path',{staticClass:"error-path",attrs:{"d":"M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z"}})])])]):_vm._e(),_c('span',{staticClass:"n-input__informations"},[_vm._t("informations")],2),_c('div',{staticClass:"n-input__bottom-area"},[_c('p',{staticClass:"n-input__error-text",style:({'color': _vm.errorColor })},[(_vm.showError && _vm.displayError)?_c('span',{domProps:{"innerHTML":_vm._s(errors[0])}}):_vm._e()])])])]}}],null,true)})],1)};
  var __vue_staticRenderFns__ = [];

    /* style */
    var __vue_inject_styles__ = function (inject) {
      if (!inject) { return }
      inject("data-v-2e40d312_0", { source: ".n-input[data-v-2e40d312]{width:100%;box-sizing:border-box}.n-input .n-input__error-icon[data-v-2e40d312],.n-input .n-input__field-icon[data-v-2e40d312]{position:absolute;right:.1em;width:1em;height:1em;transition:all .3s ease;text-align:center;line-height:1em}.n-input__container[data-v-2e40d312]{position:relative;width:100%}.n-input__container .n-input__error-icon span[data-v-2e40d312],.n-input__container .n-input__field-icon span[data-v-2e40d312]{opacity:0}.n-input__container .n-input__label-text[data-v-2e40d312]{display:block;font-size:1em;font-family:inherit;margin-bottom:.5em}.n-input__container .n-input__label-text span[data-v-2e40d312]{display:block}.n-input__container.error .n-input__error-icon span[data-v-2e40d312]{color:#ff3b30;opacity:1}.n-input__container.disabled[data-v-2e40d312]{pointer-events:none;opacity:.5}.n-input input[data-v-2e40d312]{font-size:1.1em;box-shadow:none;border:none;font-family:inherit;box-sizing:border-box;transition:border-color .3s ease;padding:.5em .7em .5em .7em;width:100%}.n-input input[data-v-2e40d312]::placeholder{color:#8d8d8d}.n-input.n-input-line input[data-v-2e40d312]{border-bottom-width:1px;border-radius:0;padding-left:0;border-bottom-style:solid}.n-input.n-input-line input[data-v-2e40d312]:focus{outline-width:1px;outline-style:solid;outline-offset:3px}.n-input.n-input-line .n-input__error-text[data-v-2e40d312]{line-height:1em}.n-input.n-input-box input[data-v-2e40d312]{border-radius:3px;border-width:1px;border-style:solid}.n-input.n-input-box input[data-v-2e40d312]:focus{outline:0}.n-input.n-input-box .n-input__error-text[data-v-2e40d312]{line-height:.8em}.n-input .n-input__bottom-area[data-v-2e40d312]{min-height:1em;box-sizing:border-box;margin-top:7px}.n-input .n-input__error-text[data-v-2e40d312],.n-input .n-input__informations[data-v-2e40d312]{font-family:inherit;font-size:.7em;margin:0}.n-input input:focus+.n-input__error-icon[data-v-2e40d312],.n-input input:focus+.n-input__field-icon[data-v-2e40d312],.n-input input:hover+.n-input__error-icon[data-v-2e40d312]{display:none}.n-input .error-icon .error-path[data-v-2e40d312]{fill:#ff3b30}", map: undefined, media: undefined });

    };
    /* scoped */
    var __vue_scope_id__ = "data-v-2e40d312";
    /* module identifier */
    var __vue_module_identifier__ = undefined;
    /* functional template */
    var __vue_is_functional_template__ = false;
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    var __vue_component__ = normalizeComponent(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      false,
      createInjector,
      undefined,
      undefined
    );

  //
  var script$1 = {
    name: 'n-mask',
    mixins: [nInput],
    props: {
      mask: {
        required: true
      },
      type: {
        type: String,
        default: 'tel',
        required: false,
        validator: function validator (maskType) {
          return ['tel', 'text'].indexOf(maskType) !== -1
        }
      },
      designType: {
        type: String,
        required: false,
        default: 'line',
        validator: function (animationType) {
          return ['box', 'line'].indexOf(animationType) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: '#F3F3F3'
      }
    },
    components: {
      TheMask: vueTheMask.TheMask
    },
    data: function data () {
      return {
        isFocus: false
      }
    },
    computed: {
      inputField: function inputField () { return this.$refs.inputField },
      hasSlots: function hasSlots () { return Object.keys(this.$slots).length > 0 },
      hasLabel: function hasLabel () { return Object.keys(this.$slots).length > 0 && this.$slots.label },
      hasInfos: function hasInfos () { return Object.keys(this.$slots).length > 0 && this.$slots.informations },
      hasIcon: function hasIcon () { return Object.keys(this.$slots).length > 0 && this.$slots.icon },
      isEmpty: function isEmpty () { return this.value === '' || this.value === null || this.value === undefined },
      ogValue: function ogValue () { return this.value },
      showError: function showError () { return (!this.isEmpty && Object.keys(this.$refs.provider.failedRules)[0] && !Object.keys(this.$refs.provider.failedRules)[0].includes('required')) || !this.isFocus }
    },
    mounted: function mounted () {
      if (!this.isEmpty) {
        this.isValid();
      }
    },
    watch: {
      ogValue: 'isValid',
      forceValidate: function forceValidate (newVal, oldVal) {
        if (newVal) {
          this.isValid();
        }
      }
    },
    methods: {
      blur: function blur () {
        this.isFocus = false;
        this.$emit('onBlur', true);
        this.isValid();
      },
      focus: function focus () {
        this.isFocus = true;
        this.$emit('onBlur', false);
      },
      isValid: function isValid () {
        var this$1 = this;

        this.$refs.provider.validate(this.value)
          .then(function (result) {
            this$1.$emit('isValid', result.valid);
          });
      }
    }
  };

  /* script */
  var __vue_script__$1 = script$1;

  /* template */
  var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input n-mask",class:("n-input-" + _vm.designType)},[_c('ValidationProvider',{ref:"provider",attrs:{"name":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var errors = ref.errors;
  var valid = ref.valid;
  return [_c('div',{staticClass:"n-input__container",class:{ 'valid': valid && !_vm.isEmpty, 'error': !!errors[0], 'active': _vm.isFocus || !_vm.isEmpty }},[(_vm.hasSlots)?_c('label',{staticClass:"n-input__label-text",style:({ color: _vm.isFocus ? _vm.borderColor : _vm.textColor }),attrs:{"for":_vm.id}},[_c('span',[_vm._t("default")],2)]):_vm._e(),_c('the-mask',{ref:"inputField",style:({
            'color': _vm.textColor,
            'border-color': errors[0] && !_vm.isFocus ? _vm.errorColor :
            !_vm.isFocus && _vm.designType === 'box' ? _vm.backgroundColor : _vm.borderColor,
            'background-color': _vm.designType === 'line' && !_vm.isFocus ? 'transparent' : _vm.backgroundColor,
            'outline-color': errors[0] && !_vm.isFocus ? _vm.errorColor : _vm.borderColor,
            'padding-right': _vm.hasIcon ? '0.9em' : '0.7em'
          }),attrs:{"type":_vm.type,"id":_vm.id,"value":_vm.ogValue,"placeholder":_vm.placeholder,"mask":_vm.mask,"masked":true},nativeOn:{"input":function($event){return (function ($event) { return _vm.$emit('input', $event.target.value); })($event)},"focus":function($event){return _vm.focus($event)},"blur":function($event){return _vm.blur($event)}}}),(_vm.showIcons && errors[0])?_c('span',{staticClass:"n-input__error-icon",style:({'top': _vm.hasLabel ? '2.4em': '0.8em'})},[_c('span',[_c('svg',{staticClass:"error-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"12","height":"12","viewBox":"0 0 12 12"}},[_c('defs',[_c('clipPath',{attrs:{"id":"error-path"}},[_c('path',{staticClass:"error-path",attrs:{"d":"M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z"}})])]),_c('path',{staticClass:"error-path",attrs:{"d":"M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z"}})])])]):_vm._e(),(_vm.isFocus)?_c('span',{staticClass:"n-input__informations"},[_vm._t("informations")],2):_vm._e(),_c('div',{staticClass:"n-input__bottom-area"},[_c('p',{staticClass:"n-input__error-text",style:({'color': _vm.errorColor })},[(_vm.showError && _vm.displayError)?_c('span',{domProps:{"innerHTML":_vm._s(errors[0])}}):_vm._e()])])],1)]}}],null,true)})],1)};
  var __vue_staticRenderFns__$1 = [];

    /* style */
    var __vue_inject_styles__$1 = function (inject) {
      if (!inject) { return }
      inject("data-v-6fda74e2_0", { source: ".n-input[data-v-6fda74e2]{width:100%;box-sizing:border-box}.n-input .n-input__error-icon[data-v-6fda74e2],.n-input .n-input__field-icon[data-v-6fda74e2]{position:absolute;right:.1em;width:1em;height:1em;transition:all .3s ease;text-align:center;line-height:1em}.n-input__container[data-v-6fda74e2]{position:relative;width:100%}.n-input__container .n-input__error-icon span[data-v-6fda74e2],.n-input__container .n-input__field-icon span[data-v-6fda74e2]{opacity:0}.n-input__container .n-input__label-text[data-v-6fda74e2]{display:block;font-size:1em;font-family:inherit;margin-bottom:.5em}.n-input__container .n-input__label-text span[data-v-6fda74e2]{display:block}.n-input__container.error .n-input__error-icon span[data-v-6fda74e2]{color:#ff3b30;opacity:1}.n-input__container.disabled[data-v-6fda74e2]{pointer-events:none;opacity:.5}.n-input input[data-v-6fda74e2]{font-size:1.1em;box-shadow:none;border:none;font-family:inherit;box-sizing:border-box;transition:border-color .3s ease;padding:.5em .7em .5em .7em;width:100%}.n-input input[data-v-6fda74e2]::placeholder{color:#8d8d8d}.n-input.n-input-line input[data-v-6fda74e2]{border-bottom-width:1px;border-radius:0;padding-left:0;border-bottom-style:solid}.n-input.n-input-line input[data-v-6fda74e2]:focus{outline-width:1px;outline-style:solid;outline-offset:3px}.n-input.n-input-line .n-input__error-text[data-v-6fda74e2]{line-height:1em}.n-input.n-input-box input[data-v-6fda74e2]{border-radius:3px;border-width:1px;border-style:solid}.n-input.n-input-box input[data-v-6fda74e2]:focus{outline:0}.n-input.n-input-box .n-input__error-text[data-v-6fda74e2]{line-height:.8em}.n-input .n-input__bottom-area[data-v-6fda74e2]{min-height:1em;box-sizing:border-box;margin-top:7px}.n-input .n-input__error-text[data-v-6fda74e2],.n-input .n-input__informations[data-v-6fda74e2]{font-family:inherit;font-size:.7em;margin:0}.n-input input:focus+.n-input__error-icon[data-v-6fda74e2],.n-input input:focus+.n-input__field-icon[data-v-6fda74e2],.n-input input:hover+.n-input__error-icon[data-v-6fda74e2]{display:none}.n-input .error-icon .error-path[data-v-6fda74e2]{fill:#ff3b30}", map: undefined, media: undefined });

    };
    /* scoped */
    var __vue_scope_id__$1 = "data-v-6fda74e2";
    /* module identifier */
    var __vue_module_identifier__$1 = undefined;
    /* functional template */
    var __vue_is_functional_template__$1 = false;
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    var __vue_component__$1 = normalizeComponent(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      false,
      createInjector,
      undefined,
      undefined
    );

  //
  var script$2 = {
    name: 'n-checkbox',
    mixins: [nInput],
    data: function data () {
      return {
        valid: true
      }
    },
    props: {
      checkmarkColor: {
        type: String,
        default: '#000000'
      }
    },
    computed: {
      inputContainer: function inputContainer () { return this.$refs.inputContainer },
      inputField: function inputField () { return this.$refs.inputField },
      checkmark: function checkmark () { return this.$refs.checkmark },
      ogValue: function ogValue () { return this.value }
    },
    watch: {
      forceValidate: function forceValidate (newVal, oldVal) {
        if (newVal) {
          this.isValid();
        }
      }
    },
    created: function created () {
      if (!this.$slots.default) {
        console.error('[NInputs] NCheckbox requires content be provided in the slot.');
      }
    },
    methods: {
      onChange: function onChange (event) {
        this.inputContainer.classList.remove('valid');
        this.$emit('input', event.target.checked ? 1 : 0);
        this.isValid();
      },
      isValid: function isValid () {
        var this$1 = this;

        this.$refs.provider.validate(this.value)
          .then(function (result) {
            this$1.$emit('isValid', result.valid);
          });
      }
    }
  };

  /* script */
  var __vue_script__$2 = script$2;

  /* template */
  var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input n-checkbox"},[_c('ValidationProvider',{ref:"provider",attrs:{"name":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var errors = ref.errors;
  return [_c('div',{ref:"inputContainer",staticClass:"n-input__container",class:{'disabled': _vm.disabled, 'error': !!errors[0] }},[_c('label',{staticClass:"n-input__checkbox",style:({
            'color': _vm.textColor
            }),attrs:{"for":_vm.id}},[_c('input',{ref:"inputField",attrs:{"type":"checkbox","id":_vm.id},domProps:{"value":_vm.ogValue,"checked":_vm.value === 1},on:{"change":_vm.onChange}}),_c('span',{ref:"checkmark",staticClass:"n-input__checkmark",style:({'border-color': _vm.borderColor})},[_c('svg',{attrs:{"viewBox":"0 0 15 11"}},[_c('path',{staticClass:"checkmark-path",attrs:{"d":"M2.732,11.3l3.043,3.064,5.461-5.476","transform":"translate(0.025 -5.178)","stroke":_vm.checkmarkColor}})])])]),_c('label',{staticClass:"n-input__checkmark-label",style:({ color: !errors[0] ? _vm.textColor : _vm.errorColor }),attrs:{"for":_vm.id}},[_vm._t("default")],2)]),_c('div',{staticClass:"n-input__bottom-area"},[(_vm.displayError)?_c('p',{staticClass:"n-input__error-text",style:({'color': _vm.errorColor }),domProps:{"innerHTML":_vm._s(errors[0])}}):_vm._e()])]}}],null,true)})],1)};
  var __vue_staticRenderFns__$2 = [];

    /* style */
    var __vue_inject_styles__$2 = function (inject) {
      if (!inject) { return }
      inject("data-v-ecddaec6_0", { source: ".n-input[data-v-ecddaec6]{width:100%;box-sizing:border-box}.n-input .n-input__error-icon[data-v-ecddaec6],.n-input .n-input__field-icon[data-v-ecddaec6]{position:absolute;right:.1em;width:1em;height:1em;transition:all .3s ease;text-align:center;line-height:1em}.n-input__container[data-v-ecddaec6]{position:relative;width:100%}.n-input__container .n-input__error-icon span[data-v-ecddaec6],.n-input__container .n-input__field-icon span[data-v-ecddaec6]{opacity:0}.n-input__container .n-input__label-text[data-v-ecddaec6]{display:block;font-size:1em;font-family:inherit;margin-bottom:.5em}.n-input__container .n-input__label-text span[data-v-ecddaec6]{display:block}.n-input__container.error .n-input__error-icon span[data-v-ecddaec6]{color:#ff3b30;opacity:1}.n-input__container.disabled[data-v-ecddaec6]{pointer-events:none;opacity:.5}.n-input input[data-v-ecddaec6]{font-size:1.1em;box-shadow:none;border:none;font-family:inherit;box-sizing:border-box;transition:border-color .3s ease;padding:.5em .7em .5em .7em;width:100%}.n-input input[data-v-ecddaec6]::placeholder{color:#8d8d8d}.n-input.n-input-line input[data-v-ecddaec6]{border-bottom-width:1px;border-radius:0;padding-left:0;border-bottom-style:solid}.n-input.n-input-line input[data-v-ecddaec6]:focus{outline-width:1px;outline-style:solid;outline-offset:3px}.n-input.n-input-line .n-input__error-text[data-v-ecddaec6]{line-height:1em}.n-input.n-input-box input[data-v-ecddaec6]{border-radius:3px;border-width:1px;border-style:solid}.n-input.n-input-box input[data-v-ecddaec6]:focus{outline:0}.n-input.n-input-box .n-input__error-text[data-v-ecddaec6]{line-height:.8em}.n-input .n-input__bottom-area[data-v-ecddaec6]{min-height:1em;box-sizing:border-box;margin-top:7px}.n-input .n-input__error-text[data-v-ecddaec6],.n-input .n-input__informations[data-v-ecddaec6]{font-family:inherit;font-size:.7em;margin:0}.n-input input:focus+.n-input__error-icon[data-v-ecddaec6],.n-input input:focus+.n-input__field-icon[data-v-ecddaec6],.n-input input:hover+.n-input__error-icon[data-v-ecddaec6]{display:none}.n-input .error-icon .error-path[data-v-ecddaec6]{fill:#ff3b30}.n-input__error-text[data-v-ecddaec6]{line-height:.5em}.n-input__container[data-v-ecddaec6]{display:flex;flex-direction:row}.n-input__checkbox[data-v-ecddaec6]{position:relative;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;font-size:1.1em;box-shadow:none;border:none;font-family:inherit;box-sizing:border-box;width:100%;max-width:1em}.n-input__checkbox .n-input__checkmark-label[data-v-ecddaec6]{margin-left:.5em}.n-input__checkbox .n-input__checkmark[data-v-ecddaec6]{position:relative;height:.8em;min-width:.8em;width:.8em;border-radius:2px;border:1px solid;box-sizing:border-box}.n-input__checkbox .n-input__checkmark svg[data-v-ecddaec6]{position:absolute;left:1px;top:2px;opacity:0;transition:opacity .2s ease}.n-input__checkbox .n-input__checkmark svg .checkmark-path[data-v-ecddaec6]{fill:transparent;stroke-linecap:round}.n-input__checkbox input[type=checkbox][data-v-ecddaec6]{position:absolute;top:0;left:0;opacity:0}.n-input__checkbox input[type=checkbox]:checked~.n-input__checkmark svg[data-v-ecddaec6]{opacity:1}", map: undefined, media: undefined });

    };
    /* scoped */
    var __vue_scope_id__$2 = "data-v-ecddaec6";
    /* module identifier */
    var __vue_module_identifier__$2 = undefined;
    /* functional template */
    var __vue_is_functional_template__$2 = false;
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    var __vue_component__$2 = normalizeComponent(
      { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
      __vue_inject_styles__$2,
      __vue_script__$2,
      __vue_scope_id__$2,
      __vue_is_functional_template__$2,
      __vue_module_identifier__$2,
      false,
      createInjector,
      undefined,
      undefined
    );

  //
  var script$3 = {
    name: 'n-radios',
    mixins: [nInput],
    props: {
      values: {
        type: Object
      },
      selectedBackgroundColor: {
        type: String,
        default: '#000000'
      },
      selectedColor: {
        type: String,
        default: '#FFFFFF'
      },
      radioColor: {
        type: String,
        default: '#000000'
      },
      backgroundColor: {
        type: String,
        default: '#FFFFFF'
      },
      hideRadios: {
        type: Boolean,
        default: false
      },
      designType: {
        type: String,
        required: false,
        validator: function (animationType) {
          return ['box', 'default'].indexOf(animationType) !== -1
        },
        default: 'default'
      },
      labelPosition: {
        type: String,
        default: 'side',
        validator: function (type) {
          return ['side', 'above'].indexOf(type) !== -1
        }
      },
      borderType: {
        type: String,
        default: 'circle',
        validator: function (type) {
          return ['rounded', 'circle', 'squared'].indexOf(type) !== -1
        }
      }
    },
    data: function data () {
      return {
        ogValue: undefined
      }
    },
    computed: {
      provider: function provider () { return this.$refs.provider },
      isBox: function isBox () { return this.designType === 'box' },
      inputContainer: function inputContainer () { return this.$refs.inputContainer },
      hasSlots: function hasSlots () { return Object.keys(this.$slots).length > 0 }
    },
    mounted: function mounted () {
      if (this.value) {
        this.ogValue = this.value;
      }
    },
    watch: {
      ogValue: function ogValue (newVal) {
        this.$emit('input', newVal);
      },
      value: function value (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.ogValue = this.value;
          this.isValid();
        }
      },
      forceValidate: function forceValidate (newVal, oldVal) {
        if (newVal) {
          this.isValid();
        }
      }
    },
    methods: {
      isValid: function isValid () {
        var this$1 = this;

        this.$refs.provider.validate(this.value)
          .then(function (result) {
            this$1.$emit('isValid', result.valid);
          });
      }
    }
  };

  /* script */
  var __vue_script__$3 = script$3;

  /* template */
  var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input n-radios"},[_c('ValidationProvider',{ref:"provider",attrs:{"name":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var errors = ref.errors;
  return [_c('div',{ref:"inputContainer",staticClass:"n-input__container",class:{'disabled': _vm.disabled, 'error': !!errors[0] },style:({
        'flex-direction': _vm.labelPosition === 'side' ? 'row' : 'column',
        'align-items': _vm.labelPosition === 'side' ? 'center' : 'flex-start'
      })},[(_vm.hasSlots)?_c('label',{staticClass:"n-radios__label-text",style:({ 'color' : _vm.textColor, 'margin-bottom' : _vm.labelPosition === 'side' ? '0px' : '7px'})},[_c('span',[_vm._t("default")],2)]):_vm._e(),_c('div',{staticClass:"n-radios__container_flex_row"},_vm._l((_vm.values),function(val,key){return _c('label',{key:val,staticClass:"n-input__radio",class:("n-radio-" + _vm.designType),style:({
              'background-color': _vm.designType === 'box' && val === _vm.ogValue ? _vm.selectedBackgroundColor : _vm.designType === 'box' ? _vm.backgroundColor : 'none',
              'border-radius': _vm.designType === 'box' && _vm.borderType === 'circle' ? '24px' : _vm.borderType === 'rounded' ? '4px' : '0px' ,
              'padding': _vm.designType === 'box' ? '0.5em' : '0px',
              'border': _vm.designType === 'box' ? '1px solid' : 'none',
              'border-color':  _vm.designType === 'box' && val === _vm.ogValue ? _vm.selectedBackgroundColor : _vm.designType === 'box' ? _vm.borderColor : 'none'}),attrs:{"for":(_vm.id + "__" + val + "__" + key)},on:{"click":function($event){$event.preventDefault();_vm.$emit('input', val); _vm.$emit('click');}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ogValue),expression:"ogValue"}],attrs:{"type":"radio","id":(_vm.id + "__" + val + "__" + key)},domProps:{"value":val,"checked":_vm._q(_vm.ogValue,val)},on:{"change":function($event){_vm.ogValue=val;}}}),(!_vm.hideRadios)?_c('span',{staticClass:"n-input__popout",style:({
                'border-color':  _vm.designType === 'box' && val === _vm.ogValue ?  _vm.selectedColor : _vm.radioColor
              })},[_c('span',{staticClass:"n-input__popin",style:({
                  'background-color': _vm.designType === 'box' && val === _vm.ogValue ? _vm.selectedColor : 'transparent'
                })})]):_vm._e(),_c('span',{staticClass:"n-input__radio-label",style:({ color: _vm.designType === 'box' && val === _vm.ogValue ? _vm.selectedColor : _vm.textColor, 'margin-left': !_vm.hideRadios ? '0.5em' : 0 })},[_vm._v(_vm._s(key))])])}),0)]),_c('div',{staticClass:"n-input__bottom-area"},[(_vm.displayError)?_c('p',{staticClass:"n-input__error-text",style:({'color': _vm.errorColor }),domProps:{"innerHTML":_vm._s(errors[0])}}):_vm._e()])]}}],null,true)})],1)};
  var __vue_staticRenderFns__$3 = [];

    /* style */
    var __vue_inject_styles__$3 = function (inject) {
      if (!inject) { return }
      inject("data-v-58bbf9e0_0", { source: ".n-input[data-v-58bbf9e0]{width:100%;box-sizing:border-box}.n-input .n-input__error-icon[data-v-58bbf9e0],.n-input .n-input__field-icon[data-v-58bbf9e0]{position:absolute;right:.1em;width:1em;height:1em;transition:all .3s ease;text-align:center;line-height:1em}.n-input__container[data-v-58bbf9e0]{position:relative;width:100%}.n-input__container .n-input__error-icon span[data-v-58bbf9e0],.n-input__container .n-input__field-icon span[data-v-58bbf9e0]{opacity:0}.n-input__container .n-input__label-text[data-v-58bbf9e0]{display:block;font-size:1em;font-family:inherit;margin-bottom:.5em}.n-input__container .n-input__label-text span[data-v-58bbf9e0]{display:block}.n-input__container.error .n-input__error-icon span[data-v-58bbf9e0]{color:#ff3b30;opacity:1}.n-input__container.disabled[data-v-58bbf9e0]{pointer-events:none;opacity:.5}.n-input input[data-v-58bbf9e0]{font-size:1.1em;box-shadow:none;border:none;font-family:inherit;box-sizing:border-box;transition:border-color .3s ease;padding:.5em .7em .5em .7em;width:100%}.n-input input[data-v-58bbf9e0]::placeholder{color:#8d8d8d}.n-input.n-input-line input[data-v-58bbf9e0]{border-bottom-width:1px;border-radius:0;padding-left:0;border-bottom-style:solid}.n-input.n-input-line input[data-v-58bbf9e0]:focus{outline-width:1px;outline-style:solid;outline-offset:3px}.n-input.n-input-line .n-input__error-text[data-v-58bbf9e0]{line-height:1em}.n-input.n-input-box input[data-v-58bbf9e0]{border-radius:3px;border-width:1px;border-style:solid}.n-input.n-input-box input[data-v-58bbf9e0]:focus{outline:0}.n-input.n-input-box .n-input__error-text[data-v-58bbf9e0]{line-height:.8em}.n-input .n-input__bottom-area[data-v-58bbf9e0]{min-height:1em;box-sizing:border-box;margin-top:7px}.n-input .n-input__error-text[data-v-58bbf9e0],.n-input .n-input__informations[data-v-58bbf9e0]{font-family:inherit;font-size:.7em;margin:0}.n-input input:focus+.n-input__error-icon[data-v-58bbf9e0],.n-input input:focus+.n-input__field-icon[data-v-58bbf9e0],.n-input input:hover+.n-input__error-icon[data-v-58bbf9e0]{display:none}.n-input .error-icon .error-path[data-v-58bbf9e0]{fill:#ff3b30}.n-input__error-text[data-v-58bbf9e0]{line-height:.5em}.n-input__container[data-v-58bbf9e0]{display:flex;flex-direction:row;justify-content:space-between}.n-radios__label-text[data-v-58bbf9e0]{display:inline-block;font-size:1em;font-family:inherit;margin-right:1.5em}.n-radios__label-text span[data-v-58bbf9e0]{display:block}.n-radios__container_flex_row[data-v-58bbf9e0]{display:flex;flex-direction:row;width:100%;flex:1}.n-input__radio[data-v-58bbf9e0]{position:relative;display:flex;flex-direction:row;justify-content:center;align-items:center;font-size:1em;font-family:inherit;box-shadow:none;border:none;box-sizing:border-box;height:48px;margin-right:10px}.n-input__radio .n-input__popout[data-v-58bbf9e0]{display:flex;justify-content:center;align-items:center;width:1em;height:1em;border-radius:calc(50%);border:1px solid #000}.n-input__radio .n-input__popin[data-v-58bbf9e0]{width:50%;height:50%;border-radius:calc(50%);box-sizing:border-box;transition:opacity .3s ease}.n-input__radio input[type=radio][data-v-58bbf9e0]{position:absolute;top:0;left:0;opacity:0}", map: undefined, media: undefined });

    };
    /* scoped */
    var __vue_scope_id__$3 = "data-v-58bbf9e0";
    /* module identifier */
    var __vue_module_identifier__$3 = undefined;
    /* functional template */
    var __vue_is_functional_template__$3 = false;
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    var __vue_component__$3 = normalizeComponent(
      { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
      __vue_inject_styles__$3,
      __vue_script__$3,
      __vue_scope_id__$3,
      __vue_is_functional_template__$3,
      __vue_module_identifier__$3,
      false,
      createInjector,
      undefined,
      undefined
    );

  //
  var script$4 = {
    name: 'n-password',
    mixins: [nInput],
    props: {
      designType: {
        type: String,
        required: true,
        default: 'line',
        validator: function (animationType) {
          return ['box', 'line'].indexOf(animationType) !== -1
        }
      },
      revealColor: {
        type: String,
        default: '#000000'
      },
      backgroundColor: {
        type: String,
        default: '#F3F3F3'
      }
    },
    data: function data () {
      return {
        type: 'password',
        password: ''
      }
    },
    components: {
      NText: __vue_component__
    },
    methods: {
      isValid: function isValid (valid) {
        this.$emit('isValid', valid);
      },
      setType: function setType () {
        if (this.password.length > 0) {
          this.type = this.type === 'password' ? 'text' : 'password';
        }
      }
    },
    computed: {
      ie11: function ie11 () { return !!window.MSInputMethodContext && !!document.documentMode },
      hasLabel: function hasLabel () { return Object.keys(this.$slots).length > 0 && this.$slots.default }
    },
    watch: {
      password: function password (newval) {
        this.$emit('input', newval);
      }
    }
  };

  /* script */
  var __vue_script__$4 = script$4;

  /* template */
  var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-input n-password"},[_c('NText',{attrs:{"name":_vm.name,"type":_vm.type,"rules":_vm.rules,"designType":_vm.designType,"placeholder":_vm.placeholder,"borderColor":_vm.borderColor,"backgroundColor":_vm.backgroundColor,"textColor":_vm.textColor,"errorColor":_vm.errorColor,"showIcons":false,"disabled":_vm.disabled,"forceValidate":_vm.forceValidate,"displayError":_vm.displayError},on:{"isValid":_vm.isValid},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"informations",fn:function(){return [_vm._t("informations")]},proxy:true}],null,true),model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v;},expression:"password"}}),(!_vm.ie11)?_c('a',{staticClass:"reveal",class:{'clickable': _vm.password.length > 0},style:({'top': _vm.hasLabel ? '2.3em': '0.6em'}),on:{"click":_vm.setType}},[_vm._t("icon",[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"15","height":"10","viewBox":"0 0 15 10"}},[_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{staticClass:"contour",attrs:{"d":"M827.5-1837.638a8.359,8.359,0,0,0-7.5-4.862,8.359,8.359,0,0,0-7.5,4.862v.275a8.247,8.247,0,0,0,7.5,4.862,8.359,8.359,0,0,0,7.5-4.862Zm-7.5,4.312a7.6,7.6,0,0,1-6.5-4.128,7.473,7.473,0,0,1,6.5-4.128,7.6,7.6,0,0,1,6.5,4.128A7.726,7.726,0,0,1,820-1833.326Zm0-6.881a2.832,2.832,0,0,0-3,2.752,2.833,2.833,0,0,0,3,2.752,2.833,2.833,0,0,0,3-2.752A2.832,2.832,0,0,0,820-1840.206Zm0,4.587a1.928,1.928,0,0,1-2-1.835,1.928,1.928,0,0,1,2-1.835,1.928,1.928,0,0,1,2,1.835A1.928,1.928,0,0,1,820-1835.619Z","transform":"translate(-812.5 1842.5)"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('path',{staticClass:"eye",attrs:{"d":"M192-1853.992H844V-2265H192Z","transform":"translate(-192 2265)"}})])]),_c('g',{staticClass:"c",style:({'opacity' : _vm.type === 'password' ? 0.5 : 1}),attrs:{"fill":_vm.revealColor}},[_c('g',{staticClass:"d",attrs:{"transform":"translate(-620.5 -387.614)"}},[_c('path',{staticClass:"b",attrs:{"d":"M807.5-1847.5h25v19.174h-25Z","transform":"translate(-192 2230.527)"}})])])])])],2):_vm._e()],1)};
  var __vue_staticRenderFns__$4 = [];

    /* style */
    var __vue_inject_styles__$4 = function (inject) {
      if (!inject) { return }
      inject("data-v-6a7fe402_0", { source: ".n-input[data-v-6a7fe402]{width:100%;box-sizing:border-box}.n-input .n-input__error-icon[data-v-6a7fe402],.n-input .n-input__field-icon[data-v-6a7fe402]{position:absolute;right:.1em;width:1em;height:1em;transition:all .3s ease;text-align:center;line-height:1em}.n-input__container[data-v-6a7fe402]{position:relative;width:100%}.n-input__container .n-input__error-icon span[data-v-6a7fe402],.n-input__container .n-input__field-icon span[data-v-6a7fe402]{opacity:0}.n-input__container .n-input__label-text[data-v-6a7fe402]{display:block;font-size:1em;font-family:inherit;margin-bottom:.5em}.n-input__container .n-input__label-text span[data-v-6a7fe402]{display:block}.n-input__container.error .n-input__error-icon span[data-v-6a7fe402]{color:#ff3b30;opacity:1}.n-input__container.disabled[data-v-6a7fe402]{pointer-events:none;opacity:.5}.n-input input[data-v-6a7fe402]{font-size:1.1em;box-shadow:none;border:none;font-family:inherit;box-sizing:border-box;transition:border-color .3s ease;padding:.5em .7em .5em .7em;width:100%}.n-input input[data-v-6a7fe402]::placeholder{color:#8d8d8d}.n-input.n-input-line input[data-v-6a7fe402]{border-bottom-width:1px;border-radius:0;padding-left:0;border-bottom-style:solid}.n-input.n-input-line input[data-v-6a7fe402]:focus{outline-width:1px;outline-style:solid;outline-offset:3px}.n-input.n-input-line .n-input__error-text[data-v-6a7fe402]{line-height:1em}.n-input.n-input-box input[data-v-6a7fe402]{border-radius:3px;border-width:1px;border-style:solid}.n-input.n-input-box input[data-v-6a7fe402]:focus{outline:0}.n-input.n-input-box .n-input__error-text[data-v-6a7fe402]{line-height:.8em}.n-input .n-input__bottom-area[data-v-6a7fe402]{min-height:1em;box-sizing:border-box;margin-top:7px}.n-input .n-input__error-text[data-v-6a7fe402],.n-input .n-input__informations[data-v-6a7fe402]{font-family:inherit;font-size:.7em;margin:0}.n-input input:focus+.n-input__error-icon[data-v-6a7fe402],.n-input input:focus+.n-input__field-icon[data-v-6a7fe402],.n-input input:hover+.n-input__error-icon[data-v-6a7fe402]{display:none}.n-input .error-icon .error-path[data-v-6a7fe402]{fill:#ff3b30}.n-password[data-v-6a7fe402]{position:relative}.n-password .reveal[data-v-6a7fe402]{position:absolute;right:.8em;pointer-events:none}.n-password .reveal.clickable[data-v-6a7fe402]{cursor:pointer;pointer-events:auto}.n-password .reveal svg .c[data-v-6a7fe402]{clip-path:url(#a)}", map: undefined, media: undefined });

    };
    /* scoped */
    var __vue_scope_id__$4 = "data-v-6a7fe402";
    /* module identifier */
    var __vue_module_identifier__$4 = undefined;
    /* functional template */
    var __vue_is_functional_template__$4 = false;
    /* style inject SSR */
    
    /* style inject shadow dom */
    

    
    var __vue_component__$4 = normalizeComponent(
      { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
      __vue_inject_styles__$4,
      __vue_script__$4,
      __vue_scope_id__$4,
      __vue_is_functional_template__$4,
      __vue_module_identifier__$4,
      false,
      createInjector,
      undefined,
      undefined
    );

  exports.NCheckbox = __vue_component__$2;
  exports.NMask = __vue_component__$1;
  exports.NPassword = __vue_component__$4;
  exports.NRadios = __vue_component__$3;
  exports.NText = __vue_component__;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
